module.exports = __webpack_public_path__ + "static/media/error-404.5b9eccbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/error-404.png
// module id = 909
// module chunks = 0